import { FC } from "react"
import { ReactComponent as BackArrow } from "icons/lib/back-arrow.svg"
import { OutlinedButton, ButtonProps } from "dash-styled"

interface OutlinedBackButtonProps extends ButtonProps {
    onClick?: () => void
}

const BackArrowIcon = () => <BackArrow className="w-3 h-3 mr-2" />
export const OutlinedBackButton: FC<OutlinedBackButtonProps> = ({
    onClick,
    ...props
}) => {
    const handleClick = onClick === undefined ? undefined : () => onClick()
    return (
        <OutlinedButton
            className="w-max-content transition-none mx-2 bg-transparent text-rhino-250 shadow-none rounded px-4 py-3"
            onClick={handleClick}
            label="Go back"
            Icon={BackArrowIcon}
            {...props}
        />
    )
}
